import { createContext, ReactNode, useContext } from 'react'

const IsCollaboratorViewContext = createContext(false)

export function useIsCollaboratorView(): boolean {
  return useContext(IsCollaboratorViewContext)
}

interface IsCollaboratorViewProviderProps {
  children: ReactNode
  isCollaboratorView?: boolean
}

export default function IsCollaboratorViewProvider({
  children,
  isCollaboratorView = false,
}: IsCollaboratorViewProviderProps) {
  return <IsCollaboratorViewContext.Provider value={isCollaboratorView}>{children}</IsCollaboratorViewContext.Provider>
}
